export default __webpack_public_path__ + "static/second-9f7523ef3843ec16a70288c118ca9874.png";